import { render, staticRenderFns } from "./yi_cascader.vue?vue&type=template&id=1503ca2e&scoped=true&"
import script from "./yi_cascader.vue?vue&type=script&lang=js&"
export * from "./yi_cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503ca2e",
  null
  
)

export default component.exports